import { useSnapshot } from 'valtio';

import Text from '@cartwhl/ui/base/Text';
import Panel from '@cartwhl/ui/layout/Panel';

import { characterPickerStore, uiStore } from 'stores';

import { hasFace, hasSkinTone } from '../utils';
import AvatarPicker from './AvatarPicker';
import CharacterCreationOptions from './CharacterCreationOptions';
import Facepicker from './FacePicker';
import HandPicker from './HandPicker';
import SkinTonePicker from './SkinTonePicker';

export default function CharacterPanel({
  close,
  isOpen,
  enterTransitionDuration = 0,
  exitTransitionDuration = 0,
}: {
  close: () => void;
  isOpen?: boolean;
  enterTransitionDuration?: number;
  exitTransitionDuration?: number;
}) {
  const { activeCharacter } = useSnapshot(characterPickerStore.state);
  const { subPanelKey } = useSnapshot(uiStore.state);

  return (
    <Panel
      title="Character"
      subPanelKey={subPanelKey}
      closePanel={close}
      isOpen={isOpen}
      enterTransitionDuration={enterTransitionDuration}
      exitTransitionDuration={exitTransitionDuration}
    >
      <div className="flex flex-col gap-6">
        <div>
          <Text
            variant="studio/body/medium/sm"
            className="mb-2 flex h-[34px] items-center"
          >
            Upload &amp; Create
          </Text>
          <CharacterCreationOptions />
        </div>

        <div>
          <Text
            variant="studio/body/medium/sm"
            className="mb-2 flex h-[34px] items-center"
          >
            Configure character
          </Text>
          <div className="flex flex-col gap-2">
            <AvatarPicker />
            <HandPicker />
            {hasFace(activeCharacter) && <Facepicker />}
            {hasSkinTone(activeCharacter) && <SkinTonePicker />}
          </div>
        </div>
      </div>
    </Panel>
  );
}
